// extracted by mini-css-extract-plugin
export default {"journal":"assignment_journal__aEz1J"};